function AltLinkMissing() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>An image without alternative text results in an empty link.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Images that are the only thing within a link must have descriptive alternative text. If an image is within a link that contains no text and that image does not provide alternative text, a screen reader has no content to present to the user regarding the function of the link.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Add appropriate alternative text that presents the content of the image and/or the function of the link.</p>
    </blockquote>
  )
}

export default AltLinkMissing